<template>
  <div class="player">
    <div v-if="playCode" class="video"
         :id="'tcplayer' + playCode"
         ref="tcplayer"
         style="width:100%;height: 100%"></div>
        
           <!-- <div class="loading" v-if="playLoading">
        
          <span></span>
           <span></span>
            <span></span>
             <span></span>
              <span></span>

         </div>
      -->
     <div v-if="playLoading" class="loadingbox">
      <img src="@/assets/starting.gif"
           alt="">
    </div>
  </div>
</template>

<script>
export default {

  name: "TcPlayerUnit",
  components: {},
  props: {
    code: {
      Type: String,
      default: "",

    }
  },
  data () {
    return {
      player: "",
      playCode: "",
      playUrl: "",
      playLoading:false
    };
  },
  watch: {
    code: {
      handler (val) {
        console.log(val)
        if (val) {
          if(this.playCode!=val&&this.playCode){
          }
          if (this.playCode == val) return
          this.playCode = val
          this.getPlayUrl()
        }else{
          if(this.playCode){
              this.playCode= ''
               this.player.destroy();
               this.playUrl=''
          }
        }
      },
      deep:true,
      immediate: true
    }

  },
  created () { },
  mounted () {
  },
  beforeDestroy(){
     let dom = document.getElementById("tcplayer" + this.playCode);
      while (dom&& dom.hasChildNodes()) {
        // 当存在子节点时 销毁视频
        this.player.destroy();
      }
  },
  methods: {
    restartPlayer (e) {
      console.log(e)
    },
    getPlayUrl () {
      this.playLoading =true
      let dom = document.getElementById("tcplayer" + this.playCode);
      while (dom&& dom.hasChildNodes()) {
        // 当存在子节点时 销毁视频
        this.player.destroy();
      }
      //  this.playUrl = 'http://192.168.1.142:8080/01/01.flv'
      //   this.player = new WasmPlayer(null, "tcplayer" + this.code, this.callbackfun, {
      //     openAudio: false
      //   })
       
      this.$playHttp.hxgCameraPlay({ cameraIndexCode: this.playCode, streamType: 0, protocol: "httpflv", transmode: 1 }).then(res => {
        console.log(res)
        if(res.data.data.url.includes('http://www.safedsj.com:8950/openUrl')){
           this.playUrl  ='https://safe.zzsasoft.com/live/'+ res.data.data.url.split(':8950/openUrl/')[1]
           this.player = new WasmPlayer(null, "tcplayer" + this.code, this.callbackfun, {
          openAudio: false
        })
        
         setTimeout(() => {
            this.player.play(this.playUrl, 1)
            
        }, 1000);
        
        }
       
     
       
      })
      // console.log(dom);


    },
    callbackfun (e) {
      if(e=='videoTimestamp'){
        setTimeout(()=>{
         this.playLoading =false
        },1000)
      }
    },
  },
  destroyed () {
    this.player.destroy();
    // 页面销毁，同时也销毁 TcPlayer
  }
};
</script>
<style lang="scss" scoped>
.player {
  width: 100%;
 height:100%;
 overflow: hidden;
  position: relative;
  ::v-deep .video {
    width: 100%;
    height: 100%;
    .vcp-player {
      width: 100%;
       height:100%;

    // height:calc(100% - 30px);

      video {
        width: 100%;
         height:100%;

      //   height:calc(100% - 30px);

        object-fit: fill;
      }
    }
  }
  /deep/video {
        width: 100%;
         height:calc(100% - 30px);

        object-fit: fill;
      }
}
.loading{
        width: 120px;
        height: 60px;
        display: flex;
        justify-content: space-between;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        span{
            display: inline-block;
                width: 8px;
                height: 100%;
                border-radius: 4px;
                background: #8DB3FF;
                -webkit-animation: load 1.5s ease infinite;
                animation: load 1.5s ease infinite;
        }
        
    }
    @keyframes load {
        0%{
            height: 60px;
            background: #8DB3FF;
        } 
        50% {
            height: 40px;
            margin: -1px 0;
            background: #0256FF ;
            opacity: .14;
        }
        100% {
            height: 60px;
            background: #8DB3FF;
        }
    }
    .loading span:nth-child(2){
            -webkit-animation-delay: 0.2s;
            animation-delay: 0.2s;
    }
    .loading span:nth-child(3){
            -webkit-animation-delay: 0.4s;
            animation-delay: 0.4s;
    }
    .loading span:nth-child(3){
            -webkit-animation-delay: 0.6s;
            animation-delay: 0.6s;
    }
    .loading span:nth-child(4){
            -webkit-animation-delay: 0.8s;
            animation-delay: 0.8s;
    }
  .loadingbox {
  position: absolute;
  top: 0;
  left: 0;
  background: #000;
  height: 100%;
  width: 100%;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loadingbox img {
  width: 400px;
}
</style>
